import { AnimatedSpriteWrap } from "common/pixi/animatedSprite";
import * as R from "ramda";
export class Background {
    constructor(pixiContext, sheets) {
        const textures = R.flatten(R.map((sheet) => sheet.animationTextures(fileName), sheets));
        const sprite = new AnimatedSpriteWrap(pixiContext, textures);
        sprite.anchor.set(0.5, 0.5);
        this.sprite = sprite;
        this.sprite.animationSpeed = 0.3;
    }
}
export const fileName = "background";
//# sourceMappingURL=background.js.map